export default "__VITE_ASSET__OH0BQkcM__"